var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 11,
    viewBox: "0 0 27 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8b057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f9e8a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dab145"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806",
    transform: "translate(-78 -426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    transform: "translate(-4 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11558",
    "data-name": "Path 11558",
    d: "M2,0H27L25,10H0Z",
    transform: "translate(82 423)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "TOP",
    transform: "translate(96 432)",
    fill: "#222f2d",
    fontSize: 10,
    fontFamily: "Roboto-BoldItalic, Roboto",
    fontWeight: 700,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -9,
    y: 0
  }, "TOP"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.a2b2b690fd0bdaa00dd4c440e8ca4a10.svg";
export { ForwardRef as ReactComponent };